import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Browser = function Browser(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? 'var(--color-primary-light-400)' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M44 44H4V7C4 5.35 5.35 4 7 4H41C42.65 4 44 5.35 44 7V44ZM6 42H42V7C42 6.45 41.55 6 41 6H7C6.45 6 6 6.45 6 7V42Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M40 8H38V10H40V8Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M36 8H34V10H36V8Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M32 8H30V10H32V8Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M43 12H5V14H43V12Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M22 30H9V17H22V30ZM11 28H20V19H11V28Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M39 33H9V35H39V33Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M39 17H25V19H39V17Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M35 22H25V24H35V22Z",
      fill: secondaryColor
    })]
  });
};
export default Browser;